import axios, { AxiosResponse, AxiosError, AxiosPromise } from "axios";
import { getV2AxiosRequestConfig } from "us.helper/utility";

const errorInterceptor = (error: AxiosError) => {
  switch (error?.response?.status) {
    case 400:
      break;

    case 401:
      break;

    case 404:
      break;

    default:
  }
  return Promise.reject({ httpCode: error?.response?.status, error });
};

const responseInterceptor = (response: AxiosResponse) => {
  switch (response.status) {
    case 200:
      break;
    default:
  }

  return response;
};

const axiosInstance = axios.create({
  baseURL: window._ENV.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  transformResponse: [
    function (data) {
      let response;
      try {
        response = JSON.parse(data);
      } catch (error) {
        throw error;
      }
      return response.hasOwnProperty("result") ? response?.result : response;
    },
  ],
});

// Set the auth token for any request
axiosInstance.interceptors.request.use(getV2AxiosRequestConfig);

axiosInstance.interceptors.response.use(responseInterceptor, errorInterceptor);

const AzureHttp = {
  post: function <D extends {} | Array<{}>>(
    service: string,
    endpoint: string,
    data: D
  ): AxiosPromise {
    return axiosInstance.post(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}`,
      data
    );
  },
  put: function <D extends {} | Array<{}>>(
    service: string,
    endpoint: string,
    data: D
  ): AxiosPromise {
    return axiosInstance.put(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}`,
      data
    );
  },
  putById: function (
    service: string,
    endpoint: string,
    id: number | string
  ): AxiosPromise {
    return axiosInstance.put(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}/${id}`
    );
  },
  get: function <D extends {} | Array<{}>>(
    service: string,
    endpoint: string,
    data: D
  ): AxiosPromise {
    return axiosInstance.get(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}`,
      {
        params: data,
      }
    );
  },
  getById: function (
    service: string,
    endpoint: string,
    id: number | string
  ): AxiosPromise {
    return axiosInstance.get(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}/${id}`
    );
  },
  getByType: function (
    service: string,
    endpoint1: string,
    id: number | string,
    endpoint2: string,
    type: number | string,
    subType: number | string
  ): AxiosPromise {
    return axiosInstance.get(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint1}/${id}/${endpoint2}/${type}/${subType}`
    );
  },
  delete: function (
    service: string,
    endpoint: string,
    id: number | string
  ): AxiosPromise {
    return axiosInstance.delete(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}/${id}`
    );
  },
  patch: function <D extends {} | Array<{}>>(
    service: string,
    endpoint: string,
    data: D
  ): AxiosPromise {
    return axiosInstance.patch(
      `/${service}-${window._ENV.REACT_APP_COLLECTION_API_ENV}/${endpoint}`,
      data
    );
  },
};

export default AzureHttp;
